import store from '@/store/store'

export default {
  methods: {
    // Format a data passada como parâmetro para o formato "00/00/0000"
    /**
     * @param {Date} date - Data (00-00-0000)
     */
    formatDate(date) {
      if (date !== null) {
        let dataSplit = date.split('-')

        let day = dataSplit[2]
        let month = dataSplit[1]
        let year = dataSplit[0]

        day = day.substring(0, 2)

        return day + '/' + month + '/' + year
      } else {
        return ''
      }
    },

    /* Retorna a diferença de dias entre a data atual e a data passada como parâmetro */
    /**
     * @param {Date} date - Data (0000-00-00)
     */
    diffDays(date) {
      if (date != null) {
        let now = new Date() // Data de hoje

        // data passada por parametro
        let dataSplit = date.split('-')
        let day = dataSplit[2]
        let month = dataSplit[1]
        let year = dataSplit[0]
        let date1 = new Date(year, month - 1, day)

        let timeDiff = Math.abs(now.getTime() - date1.getTime())
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

        return parseInt(diffDays)
      }
    },

    /* Retorna a diferença de dias entre datas*/
    /**
     * @param {Date} date1 - Data (0000-00-00)
     * @param {Date} date2 - Data (0000-00-00)
     */
    differenceOfDaysBetweenTwoDates(date1, date2) {
      // date 1
      let date1Split = date1.split('-')
      let day1 = date1Split[2]
      let month1 = date1Split[1]
      let year1 = date1Split[0]
      let dateFormat1 = new Date(year1, month1 - 1, day1)

      // date 2
      let date2Split = date2.split('-')
      let day2 = date2Split[2]
      let month2 = date2Split[1]
      let year2 = date2Split[0]
      let dateFormat2 = new Date(year2, month2 - 1, day2)

      let timeDiff = Math.abs(dateFormat2.getTime() - dateFormat1.getTime())
      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

      return diffDays
    },

    // Retorna um profissional ACS aleatório do array
    /**
     * @param {Array} profissionais
     */
    getRandomProfissionalAcs(profissionais) {
      let randomProfissional =
        profissionais[Math.floor(Math.random() * profissionais.length)]
      if (randomProfissional.nu_cpf === 'todos') {
        this.getRandomProfissionalAcs(profissionais)
      }
      return randomProfissional
    },

    /**
     * Remove valores duplicados do array de acordo com a propriedade
     * @param {Array} items - Array de itens a serem removidos
     * @param {String} prop - Propriedade a ser comparada
     * @returns {Array} - Array de itens sem duplicidade
     */
    removeDuplicate(items, prop) {
      const checkedItems = {}

      const uniqueArray = items.filter((item) => {
        const value = item[prop]
        const isUnique = !checkedItems[value]
        if (isUnique) {
          checkedItems[value] = true
        }
        return isUnique
      })

      return uniqueArray
    },

    /***
     * Verifica se a permissão do card está ativa
     * @param {Array} data - Array de permissões
     * @param {String} key - Nome da chave do objeto
     * @param {String} dataKey - Valor da chave do objeto
     * @returns {Array} - Array com os cards permitidos
     */
    checkCardPermission(data, key, dataKey) {
      let response = data.find((element) => {
        return key == element.key && dataKey == '1'
      })
      if (response !== undefined) {
        return {
          ...response,
          ativo: Number(dataKey),
        }
      }
    },

    /**
     * Checa se existe propriedade no object independente do nível
     * @param {Object} obj - Objeto onde será buscado o item
     * @param {string} propName - Propriedade a ser buscada no objeto
     * @returns {Boolean} - Valor encontrado ou não
     */
    deepCheckPropInObj(obj, propName) {
      if (obj[propName]) return true
      if (Object.keys(obj).length <= 0) return false
      return Object.keys(obj) // Turns keys of object into array of strings
        .map((prop) => {
          if (typeof obj[prop] === 'object') {
            return this.deepCheckPropInObj(obj[prop], propName)
          } else {
            return prop === propName // Return true or false
          }
        }) // The result is an array like [false, false, true, false]
        .reduce(function (previousValue, currentValue, index, array) {
          return previousValue || currentValue
        })
      // Do an 'or', or comparison of everything in the array.
      // It returns true if at least one value is true.
    },

    /**
     * Encontra todas as entradas de determinada propriedade no objeto
     * @param {Object} obj - Objeto a ser iterado
     * @param {string} keyToFind - Propriedade a ser buscada no objeto
     * @returns {Array} - Retorna todas as entradas encontradas
     */
    findAllByKeyInObject(obj, keyToFind) {
      return Object.entries(obj).reduce(
        (acc, [key, value]) =>
          key === keyToFind
            ? acc.concat(value)
            : typeof value === 'object'
            ? acc.concat(this.findAllByKeyInObject(value, keyToFind))
            : acc,
        []
      )
    },

    /**
     * Constrói uma string com o caminho para acessar a propriedade no objeto
     * @param {string} property - Propriedade alvo
     * @param {Object} obj - Objeto que contém a propriedade a ser encontrada
     * @returns {string} - Caminho para acessar a propriedade
     */
    findObjectPath(property, obj) {
      for (const key in obj) {
        if (obj[key]) {
          if (property === key) return key
          else if (obj[key] && typeof obj[key] === 'object') {
            const path = this.findObjectPath(property, obj[key])
            if (path) return key + '.' + path
          }
        }
      }
    },

    /**
     * Checa se uma propriedade existe num objeto
     * @param {Object} obj - Objeto aonde vai ser realizada a busca
     * @param {string} prop - Nome da prop sendo buscada
     * @returns {Boolean} - True caso a propriedade exista dentro do objeto
     */
    checkPropInObj(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop)
    },

    /**
     * Simple object check
     * @param item
     * @returns {boolean}
     */
    isObject(item) {
      return !!item && typeof item === 'object' && !Array.isArray(item)
    },

    /**
     * Deep merge de dois objetos
     * @param target
     * @param ...sources
     */
    mergeDeep(target, ...sources) {
      if (!sources.length) return target
      const source = sources.shift()

      if (isObject(target) && isObject(source)) {
        for (const key in source) {
          if (isObject(source[key])) {
            if (!target[key]) {
              target[key] = {}
            }
            this.mergeDeep(target[key], source[key])
          } else {
            target[key] = source[key]
          }
        }
      }

      return this.mergeDeep(target, ...sources)
    },

    /**
     * Flattens an object with the paths for keys.
     * @param {*} obj - Objeto a ser flattened
     * @param {*} prefix - Usado para recursão
     * @returns {Object} - Objeto flattened
     */
    flattenObject(obj, prefix = '') {
      Object.keys(obj).reduce((acc, k) => {
        const pre = prefix.length ? `${prefix}.` : ''
        if (
          typeof obj[k] === 'object' &&
          obj[k] !== null &&
          Object.keys(obj[k]).length > 0
        ) {
          Object.assign(acc, this.flattenObject(obj[k], pre + k))
        } else acc[pre + k] = obj[k]
        return acc
      }, {})
    },

    /**
     * Checa se objetos são iguais (incluindo suas props, subobjetos, etc)
     * @param {Object} x - Objeto 1 a ser comparado
     * @param {Object} y - Objeto 2 a ser comparado
     * @returns {Boolean} - True caso objetos sejam iguais
     */
    deepEqual(x, y) {
      const ok = Object.keys
      const tx = typeof x
      const ty = typeof y
      return x && y && tx === 'object' && tx === ty
        ? ok(x).length === ok(y).length &&
            ok(x).every((key) => this.deepEqual(x[key], y[key]))
        : x === y
    },

    titlePdf(cardTitle, equipeName) {
      let hoje = new Date()
      let dataFormatada = hoje.toLocaleDateString('pt-BR').split('/').join('-')
      return `${cardTitle}${equipeName ? `, ` + equipeName : ''}${
        `, ` + dataFormatada
      } `
    },

    /**
     * Retorna a data atual e a data de 30 dias atrás
     * @returns object
     */
    obterDataAtualE30DiasAtras() {
      // Obtenha a data atual
      const dataAtual = new Date()

      // Calcule a data de 30 dias atrás
      const data30DiasAtras = new Date()
      data30DiasAtras.setDate(dataAtual.getDate() - 30)

      // Formate as datas para retornar como strings no formato "yyyy-mm-dd"
      const dataAtualFormatada = dataAtual.toISOString().split('T')[0]
      const data30DiasAtrasFormatada = data30DiasAtras
        .toISOString()
        .split('T')[0]

      return {
        dataAtual: dataAtualFormatada,
        data30DiasAtras: data30DiasAtrasFormatada,
      }
    },

    /**
     * Converte uma img para base64
     * @param {*} src
     */
    fileToBase64(src) {
      if (src == '') {
        return new Promise((resolve, reject) => {
          resolve('')
        })
      }

      return new Promise((resolve, reject) => {
        const extension = src.split('.').pop()
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.src = src
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          const base64data = canvas.toDataURL(`image/${extension}`)
          resolve(base64data)
        }
        img.onerror = (error) => {
          reject(error)
        }
      })
    },

    /**
     * Monta o cabeçalho do PDF
     * @param {jsPDF} doc
     * @param {String} base64data
     * @param {String} title_pdf
     * @param {String} description_pdf
     * @param {Number} verticalPosition
     * @param {Number} widthLine
     * @param {String} orientation
     * @returns {Number} - Posição vertical
     */
    headerPdf(
      doc,
      base64data,
      title_pdf,
      description_pdf,
      widthLine = 200,
      orientation = 'p'
    ) {
      let verticalPosition = orientation == 'p' ? 10 : 30
      // Brasão
      const pageWidth = doc.internal.pageSize.getWidth()
      const marginXtext = pageWidth / 2
      const marginXimg = pageWidth / 2 - 10

      if (base64data != '') {
        if (orientation == 'p') {
          doc.addImage(base64data, marginXimg, verticalPosition, 20, 20)
          verticalPosition += 25
        } else {
          doc.addImage(base64data, marginXimg, verticalPosition, 40, 40)
          verticalPosition += 55
        }
      }

      doc.setFontSize(14)
      doc.text(
        store.state.cidade,
        marginXtext,
        verticalPosition,
        null,
        null,
        'center'
      )
      verticalPosition += orientation == 'p' ? 7 : 20
      doc.text(
        'SECRETARIA MUNICIPAL DE SAÚDE',
        marginXtext,
        verticalPosition,
        null,
        null,
        'center'
      )
      // Linha
      // verticalPosition += orientation == 'p' ? 2 : 10
      // doc.line(
      //   10,
      //   verticalPosition,
      //   doc.internal.pageSize.getWidth() - 10,
      //   base64data != '' ? 43 : orientation == 'p' ? 18 : 55
      // )
      verticalPosition += orientation == 'p' ? 10 : 20
      // Título
      doc.setFontSize(14)
      doc.text(title_pdf, marginXtext, verticalPosition, null, null, 'center')
      verticalPosition += orientation == 'p' ? 7 : 16
      // Descrição
      doc.setFontSize(12)
      doc.text(
        description_pdf,
        marginXtext,
        verticalPosition,
        null,
        null,
        'center'
      )
      verticalPosition += orientation == 'p' ? 14 : 24
      return verticalPosition
    },

    /**
     * Monta as informações do PDF
     * @param {jsPDF} doc
     * @param {Array} fields
     * @param {Number} verticalPosition
     * @param {String} orientation
     * @returns {Number} - posição vertical
     */
    bodyPdf(doc, fields, verticalPosition, orientation = 'p') {
      for (let i = 0; i < fields.length; i++) {
        if (
          fields[i].value != undefined &&
          fields[i].value != '' &&
          fields[i].value != 'sem-equipe'
        ) {
          doc.text(
            `${fields[i].label}: ${fields[i].value}`,
            orientation == 'p' ? 15 : 40,
            verticalPosition,
            null,
            null,
            'left'
          )
          verticalPosition += orientation == 'p' ? 6 : 16
        }
      }

      // Data atual
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(12)
      doc.text(
        `Data: ${dataAtual}`,
        orientation == 'p' ? 15 : 40,
        verticalPosition,
        null,
        null
      )
      verticalPosition += orientation == 'p' ? 6 : 16

      return verticalPosition
    },

    /**
     * Cria a tabela do PDF
     * @param {Array} data
     */
    createTablePdf(data_pdf) {
      let rows = []
      for (let i = 0; i < data_pdf.length; i++) {
        rows[i] = Object.values(data_pdf[i])
      }
      let table = []
      for (var i = 0; i < rows.length; i++) {
        var tableRow = rows[i]
        for (var i = 0; i < rows.length; i++) {
          var tableRow = rows[i]
          var rowData = []
          if (tableRow.length != 0) {
            for (var j = 0; j < tableRow.length; j++) {
              rowData.push(tableRow[j])
            }
          } else {
            continue
          }
          table.push(rowData)
        }
      }
      return table
    },

    /**
     * Monta o rodapé do PDF
     * @param {jsPDF} doc
     * @param {Number} verticalPosition
     * @param {Number} x1Line
     * @param {Number} widthLine
     * @param {String} orientation
     */
    footerPdf(
      doc,
      verticalPosition,
      x1Line = 45,
      widthLine = 170,
      orientation = 'p'
    ) {
      const pageWidth = doc.internal.pageSize.getWidth()
      const marginXtext = pageWidth / 2
      let position = verticalPosition

      // Data atual
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano

      doc.setFontSize(12)
      doc.text(
        `${store.state.cidade}, ${dataAtual}.`,
        orientation == 'p' ? 15 : 40,
        orientation == 'p' ? (position += 10) : (position += 40),
        null,
        null
      )
      // Linha
      doc.line(
        x1Line,
        orientation == 'p' ? (position += 15) : (position += 50),
        widthLine,
        position
      )
      // Responsável
      doc.setFontSize(14)
      doc.text(
        'Responsável',
        marginXtext,
        orientation == 'p' ? (position += 8) : (position += 16),
        null,
        null,
        'center'
      )
    },

    /**
     * Adiciona um rodapé centralizado com data, linha divisória e nome do responsável.
     *
     * @param {object} doc - Instância do documento jsPDF.
     * @param {number} position - Coordenada vertical inicial (y) do rodapé.
     * @param {string} [orientation='p'] - Orientação da página ('p' ou 'l').
     */
    footerPdfCentralizado(doc, verticalPosition, orientation = 'p') {
      const pageWidth = doc.internal.pageSize.getWidth()
      let position = verticalPosition

      // Data atual
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano

      doc.setFontSize(12)
      doc.text(
        `${store.state.cidade}, ${dataAtual}.`,
        orientation === 'p' ? 15 : 40,
        orientation === 'p' ? (position += 10) : (position += 40)
      )

      const lineLength = 100 // comprimento da linha
      const lineStartX = (pageWidth - lineLength) / 2
      position += orientation === 'p' ? 15 : 50
      doc.line(lineStartX, position, lineStartX + lineLength, position)

      // Responsavel centralizado
      doc.setFontSize(14)
      position += orientation === 'p' ? 8 : 16
      doc.text('Responsável', pageWidth / 2, position, { align: 'center' })
    },

    /**
     * Gera uma string aleatória
     * @param {int} length
     * @returns
     */
    generateString(length) {
      // declare all characters
      const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let result = ''
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        )
      }
      return result
    },

    /**
     * Gera a senha de segurança do PDF
     */
    encryptionPdf() {
      const pass = store.state.pdf

      const modalEncryptionPdf = document.getElementById('modalEncryptionPdf')
      modalEncryptionPdf.style.display = 'block'

      const inputPassword = modalEncryptionPdf.querySelector(
        '#modalEncryptionPdf-password'
      )
      inputPassword.value = pass

      const modalEncryptionPdfButton = document.getElementById(
        'modalEncryptionPdf-button'
      )
      modalEncryptionPdfButton.textContent = 'Copiar'
      modalEncryptionPdfButton.style.background = '#aaa'

      return {
        encryption: {
          userPassword: pass,
          // ownerPassword: 'owner',
          userPermissions: ['print', 'modify', 'copy', 'annot-forms'],
        },
      }
    },

    /**
     * @param {Number} value
     * @param { Intl.NumberFormatOptions } options
     */
    moneyBr(value, options = { style: 'currency', currency: 'BRL' }) {
      return value.toLocaleString('pt-br', options)
    },

    /**
     * Recebe um número e converte para o padrão em reais do Brasil
     * @param {Number} value
     * @returns {String}
     */
    formatPrice(value) {
      console.log(value)
      // Obter o valor atual removendo qualquer caractere que não seja número
      let valuePrice = value.replace(/[^\d]/g, '')

      // Adicionar os separadores de milhares
      var formattedPrice =
        valuePrice.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, '.') +
        '' +
        valuePrice.slice(-2)

      // Adicionar a vírgula e até dois dígitos se houver centavos
      if (formattedPrice.length > 2) {
        formattedPrice =
          formattedPrice.slice(0, -2) + ',' + formattedPrice.slice(-2)
      }

      return formattedPrice
    },

    /**
     * Converte um inteiro para uma cor em hexadecimal
     * @param {int} num
     * @returns
     */
    intToColorHex(num) {
      if (
        typeof num !== 'number' ||
        !Number.isInteger(num) ||
        num < 0 ||
        num > 0xffffff
      ) {
        throw new Error(
          'Input must be an integer between 0 and 16777215 (0xFFFFFF)'
        )
      }

      let hexColor = num.toString(16).padStart(6, '0')
      return `#${hexColor}`
    },

    calculateTimeDifference(dateString) {
      const [day, month, year] = dateString.split('/').map(Number)

      // Cria a data fornecida ajustando para o fuso horário padrão (UTC)
      const inputDate = new Date(Date.UTC(year, month - 1, day))
      const currentDate = new Date()

      // Converte a data atual para UTC para comparação justa
      const currentDateUTC = new Date(
        Date.UTC(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        )
      )

      if (isNaN(inputDate.getTime())) {
        console.error('Data inválida fornecida:', dateString)
        return 'Data inválida fornecida.'
      }

      const yearDiff =
        currentDateUTC.getUTCFullYear() - inputDate.getUTCFullYear()
      const monthDiff = currentDateUTC.getUTCMonth() - inputDate.getUTCMonth()
      const dayDiff = currentDateUTC.getUTCDate() - inputDate.getUTCDate()

      // Calcula a diferença total em meses
      let totalMonthsDifference = yearDiff * 12 + monthDiff

      // Ajuste para considerar dias no cálculo da diferença em meses
      if (dayDiff < 0) {
        totalMonthsDifference -= 1
      }

      // Ajusta para meses negativos caso a data futura esteja no passado
      if (totalMonthsDifference < 0) {
        return '0 dias'
      }

      // Se a diferença total em meses for menor que 1 mês, calcular a diferença em dias
      if (totalMonthsDifference === 0) {
        const timeDiff = Math.abs(currentDateUTC - inputDate)
        const dayDifference = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))

        if (dayDifference === 0) {
          return '0 dias'
        }

        return dayDifference === 1 ? '1 dia' : `${dayDifference} dias`
      }

      // Retorna a diferença em meses
      return totalMonthsDifference === 1
        ? '1 mês'
        : `${totalMonthsDifference} meses`
    },

    /**
     * Retorna um valor numérico de acordo com o id_funcao do usuário para habilitar o select específico
     * @returns {Number}
     */
    enableSelects() {
      const idFuncao = Number(store.state.id_funcao)

      if ([1, 2, 7].includes(idFuncao)) {
        return 1
      }

      if ([4, 8, 14, 15].includes(idFuncao)) {
        return 2
      }

      if (idFuncao === 3) {
        return 3
      }

      return 1
    },

    /**
     * Converte uma string no formato 'ddMMyyyy' para o formato ISO 'yyyy-MM-dd'.
     *
     * @param {string} dataString - String representando a data no formato 'ddMMyyyy' (ex: '18062025')
     * @returns {string} - Data convertida no formato 'yyyy-MM-dd' (ex: '2025-06-18')
     */
    converterParaDataIso(dataString) {
      // Extrai o dia: pega os dois primeiros caracteres da string
      const dia = dataString.substring(0, 2)

      // Extrai o mês: pega os dois caracteres seguintes (posição 2 a 3)
      const mes = dataString.substring(2, 4)

      // Extrai o ano: pega os quatro últimos caracteres (posição 4 a 7)
      const ano = dataString.substring(4, 8)

      // Retorna a data no formato 'yyyy-MM-dd'
      return `${ano}-${mes}-${dia}`
    },

    /**
     * Verifica se a data fornecida no formato "YYYY-MM-DD" é maior do que a data atual (hoje).
     *
     * @param {string} dateStr - A data no formato "YYYY-MM-DD"
     * @returns {boolean} - Retorna true se a data for no futuro em relação à data de hoje
     */
    dataMaiorQueDataAtual(dateStr) {
      if (!dateStr || dateStr === '0000-00-00' || dateStr == null) return false

      // Cria um objeto Date com a data de hoje e zera as horas para comparar apenas a data
      const today = new Date()
      today.setHours(0, 0, 0, 0) // Ignora o horário

      const inputDate = new Date(dateStr)

      return inputDate > today
    },

    /**
     * Retorna as datas de início e fim do quadrimestre atual,
     * bem como os meses correspondentes e o número do quadrimestre.
     *
     * @returns {{
     *   data_inicio: string,
     *   data_fim: string,
     *   mes_inicial: number,
     *   mes_final: number,
     *   quadrimestre: number
     * }}
     */
    datasQuadrimestre() {
      const hoje = new Date()
      const mesAtual = hoje.getMonth() + 1 // getMonth() retorna 0-11
      const anoAtual = hoje.getFullYear()

      let data_inicio = ''
      let data_fim = ''
      let mes_inicial = 0
      let mes_final = 0
      let quadrimestre = 0

      if (mesAtual >= 1 && mesAtual <= 4) {
        data_inicio = `${anoAtual}-01-01`
        data_fim = `${anoAtual}-04-30`
        mes_inicial = 1
        mes_final = 4
        quadrimestre = 1
      } else if (mesAtual >= 5 && mesAtual <= 8) {
        data_inicio = `${anoAtual}-05-01`
        data_fim = `${anoAtual}-08-31`
        mes_inicial = 5
        mes_final = 8
        quadrimestre = 2
      } else if (mesAtual >= 9 && mesAtual <= 12) {
        data_inicio = `${anoAtual}-09-01`
        data_fim = `${anoAtual}-12-31`
        mes_inicial = 9
        mes_final = 12
        quadrimestre = 3
      }

      return {
        data_inicio,
        data_fim,
        mes_inicial,
        mes_final,
        quadrimestre,
      }
    },

    /**
     * Retorna a idade de acordo com a data de nascimento
     * @param {string} dataNascimento
     * @returns Number
     */
    calcularIdade(dataNascimento) {
      const hoje = new Date()
      const nascimento = new Date(dataNascimento)

      let idade = hoje.getFullYear() - nascimento.getFullYear()

      const mes = hoje.getMonth() - nascimento.getMonth()

      if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--
      }

      return idade
    },

    /**
     * Verifica se um CPF é válido
     * @param {*} cpf
     * @returns {boolean}
     */
    validarCPF(cpf) {
      if (!cpf || cpf.length !== 11) return false
      if (/^(\d)\1+$/.test(cpf)) return false

      let soma = 0
      for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)

      let resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(cpf.charAt(9))) return false

      soma = 0
      for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)

      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0

      return resto === parseInt(cpf.charAt(10))
    },

    /**
     * Formata um valor no formato de um CPF
     * @param {string} v
     * @returns {string}
     */
    formatCPF(v = '') {
      const d = (v || '').replace(/\D/g, '').slice(0, 11)
      return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') || '—'
    },
  },
}
